import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { tokenStorage } from '@/services/tokenStorage';
import { ROUTES } from '@/constants/routes';
import { isEmployeeAdmin } from '@/utils/employeeAdmin';
import { useAuth } from '@/store/AuthContext';

interface EmployeeAdminRouteProps {
  children: ReactNode;
}

/** Logged-in ADMIN role, or legacy allowlisted employee-admin email. */
export function EmployeeAdminRoute({ children }: EmployeeAdminRouteProps) {
  const location = useLocation();
  const { user } = useAuth();
  const isAuthenticated = tokenStorage.isAuthenticated();
  const sessionUser = user ?? tokenStorage.getUser();

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  if (!isEmployeeAdmin(sessionUser?.role, sessionUser?.email, sessionUser?.modules)) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return children;
}
